import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProductTagForOptions } from '../types'

export const productTagsForOptionsSelector: Selector<ReduxState, ProductTagForOptions[]> = state =>
  state.productTags.productTagsForOptions
